import { ButtonBaseProps, getSpacing, ItemCard, Text } from '@rahtab/ui';
import LoadTag from 'components/LoadTag';
import React, { VFC } from 'react';

const LoadItem: VFC<LoadItemProps> = ({
  params,
  screenName,
  availableLoad,
  receivedDate,
  deliveredDate,
  assignedDate,
  distributer,
  name,
  status,
  statusCode,
}) => {
  const isAssigned = statusCode === '1';
  const isDelivered = statusCode === '2';
  const handleCaption = (type: 'text' | 'value') => {
    if (type === 'text') {
      if (isAssigned) return 'تخصیص';
      else if (isDelivered) return 'تحویل';
      else return 'وصول';
    } else {
      if (isAssigned) return assignedDate;
      else if (isDelivered) return deliveredDate;
      else return receivedDate;
    }
  };
  return (
    <ItemCard
      screenName={screenName}
      params={params}
      title={name}
      caption={
        <Text color="description" margin="none">
          زمان اعلام {handleCaption('text')}:<Text margin="none"> {handleCaption('value')}</Text>
        </Text>
      }
      statusBadge={<LoadTag statusCode={statusCode} status={status!} />}>
      <Text color="description" numberOfLines={1}>
        تخصیص دهنده:
        <Text> {distributer}</Text>
      </Text>
      <Text margin="none" color="description">
        موجودی بار:
        <Text margin="none"> {availableLoad}</Text>
      </Text>
    </ItemCard>
  );
};

export default LoadItem;

export interface LoadItemProps {
  name: string;
  distributer: string;
  status?: string;
  availableLoad: string;
  receivedDate: string;
  deliveredDate: string;
  assignedDate: string;
  statusCode: string;
  screenName: string;
  params?: ButtonBaseProps['params'];
}
